import React, { useEffect, useState } from 'react';
import './works.css';
import WorksCard from '../works-card/WorksCard';
import Sketch from '../sketch/Sketch';
import PkupLines from '../pkuplines/PkupLines';
import Weather from '../weather/Weather';

function Works() {
  const [isWorkDescVisible, setWorkDescVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const workDesc = document.querySelector('.work-desc');
      if (workDesc) {
        const workDescPosition = workDesc.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (workDescPosition.top < windowHeight && workDescPosition.bottom > 0) {
          setWorkDescVisible(true);
        } else {
          setWorkDescVisible(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div className='works'>
        <div className="work-container">
            <div className={`work-desc ${isWorkDescVisible ? 'slide-in active' : 'slide-out inactive'}`}>
                <h3>Collaboratively ensuring brands shine in the digital age, forging a fresh standard that defies convention. Uncompromising innovation at all times.</h3>
                <p>My distinct position in the realm of web design stems from my fervor for design, code, and interaction, converging to create a truly exceptional blend.</p>
            </div>
            <PkupLines/>
            <div className="projects">
              <Weather/>
              <p className="recent-works">RECENT WORKS</p>
              <WorksCard showAll={false}/>
            </div>
            <Sketch showAllSketch={false}/>
        </div>
    </div>
  )
}

export default Works